// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-d65d3850] {\n  border: 1px solid #dddee1;\n  border-color: #e9eaec;\n  background: #fff;\n  border-radius: 4px;\n  font-size: 14px;\n  position: relative;\n}\n.card[data-v-d65d3850] {\n  padding: 25px;\n}", ""]);
// Exports
module.exports = exports;
